import React from "react";
import styled from "styled-components";

import { Footer } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/view/components/footer";
import { DefaultComponentMap } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/view/configuration/component-map";

export const StyledFooterRow = styled.div`
	position: relative;
	width: 100%;
	min-height: 2.5rem;
	display: flex;
	align-items: stretch;

	> * {
		flex: 1;
	}
`;

export const StyledRowCountOverlay = styled.div`
	position: absolute;
	left: 1rem;
	top: 50%;
	transform: translateY(-50%);
	font-size: 0.875rem;
	color: #666;
	z-index: 1;
	pointer-events: none;
`;

interface OverviewFooterWithCountProps extends Footer.PropsType {
	totalCount: number | undefined;
}

export function OverviewFooterWithCount(props: OverviewFooterWithCountProps): React.ReactElement {
	const { totalCount, ...footerProps } = props;
	return (
		<StyledFooterRow>
			{totalCount !== undefined && <StyledRowCountOverlay>Ergebnisse: {totalCount}</StyledRowCountOverlay>}
			<DefaultComponentMap.Footer {...footerProps} />
		</StyledFooterRow>
	);
}
